import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import AboutPeter from './components/AboutPeter';
import PoetrySection from './components/PoetrySection';
import LiteraryQuotes from './components/LiteraryQuotes';
import SongGallery from './components/SongGallery';
import Consulting from './components/Consulting';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [language, setLanguage] = useState<'de' | 'ru'>('de');
  const [isNavFixed, setIsNavFixed] = useState(false);
  const [playingSongId, setPlayingSongId] = useState<number | null>(null);

  useEffect(() => {
    // Smooth scroll behavior for the entire page
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const handlePlayRandomSong = () => {
    const randomIndex = Math.floor(Math.random() * 18) + 1;
    setPlayingSongId(randomIndex);
    // Scroll to songs section
    const songsSection = document.getElementById('songs');
    if (songsSection) {
      songsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Hero language={language} onPlayMusic={handlePlayRandomSong} />
      <AboutPeter language={language} />
      <PoetrySection language={language} />
      <LiteraryQuotes language={language} />
      <SongGallery language={language} />
      <Consulting language={language} />
      <Contact language={language} />
      <Footer language={language} />
    </div>
  );
}
